// extracted by css-extract-rspack-plugin
export default {"indicator":"CountIndicator_indicator__rNzMY","primaryIndicator":"CountIndicator_primaryIndicator__Ij8rB","secondaryIndicator":"CountIndicator_secondaryIndicator__NxbOL"};